module.exports = __webpack_public_path__ + "static/media/cauldron.2f195b89.svg";